import StorageService from './StorageService';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { trackError } from '../utils/error.utils';
import { DEVICE_FINGERPRINT_SESSION_KEY } from '../constants/constants';

class FingerprintService {
    private static fingerprint: string | null = null;
    private static isInitialized = false;
    private static initializationPromise: Promise<void> | null = null;

    static async initialize() {
        if (this.initializationPromise) {
            return this.initializationPromise;
        }

        this.initializationPromise = (async () => {
            if (this.isInitialized) {
                return;
            }
            try {
                const sessionData = StorageService.getItem(DEVICE_FINGERPRINT_SESSION_KEY, 'sessionStorage');
                const sessionFingerprint = sessionData?.fingerprint;
                if (sessionFingerprint) {
                    this.fingerprint = sessionFingerprint;
                    this.isInitialized = true;
                    return;
                }
                await this.generateNewFingerprint();
            } catch (error) {
                trackError(error, { message: 'FingerprintService: Failed to initialize fingerprint' });
                this.clearFingerprint();
            }
            this.isInitialized = true;
        })();

        return this.initializationPromise;
    }

    private static async generateNewFingerprint() {
        try {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            const newFingerprint = result.visitorId;
            this.setFingerprint(newFingerprint);
        } catch (error) {
            trackError(error, { message: 'FingerprintService: Error generating fingerprint' });
        }
    }

    static setFingerprint(fingerprint: string | null) {
        if (!fingerprint) {
            this.clearFingerprint();
            return;
        }
        try {
            this.fingerprint = fingerprint;
            StorageService.setItem({ key: DEVICE_FINGERPRINT_SESSION_KEY, data: { fingerprint }, storageType: 'sessionStorage' });
        } catch (error) {
            trackError(error, { message: 'FingerprintService: Failed to set fingerprint' });
            this.clearFingerprint();
        }
    }

    static async getFingerprint(): Promise<string | null> {
        if (!this.isInitialized) {
            await this.initialize();
        }
        return this.fingerprint;
    }

    static clearFingerprint() {
        try {
            this.fingerprint = null;
            StorageService.removeItem(DEVICE_FINGERPRINT_SESSION_KEY, 'sessionStorage');
        } catch (error) {
            trackError(error, { message: 'FingerprintService: Failed to clear fingerprint' });
        }
    }
}

export default FingerprintService; 